import { WorkOrderComplementStatus } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { Button, Modal, Tooltip } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useWorkorderDetailContext } from '../../WorkorderDetailProvider';
import WorkOrderItemModal from '../WorkOrderItemModal';
import { useDisclosure } from '@/hooks';

interface Props {
  workOrderItemListRefresh: () => Promise<unknown>;
}

export default function WorkOrderItemAddButton(props: Props) {
  const [opened, action] = useDisclosure(false);

  const {
    workorder: { data: workOrder },
    complement: { data: complement },
  } = useWorkorderDetailContext();

  const isClosed = complement?.status === WorkOrderComplementStatus.Closed;
  const isCancelled =
    complement?.status === WorkOrderComplementStatus.Cancelled;
  const isPortoBattery = !!workOrder?.isPortoBatteryWorkOrder;

  const handleAddItemModalVisible = () => {
    if (!workOrder) {
      Modal.error({
        title: 'Não é possível adicionar item',
        content:
          'Para adicionar um item ao orçamento é necessário que os dados do orçamento selecionado sejam válidos.',
      });
    } else {
      action.toggle();
    }
  };

  const hanleModalFinish = async () => {
    action.toggle();
    await props.workOrderItemListRefresh();
  };

  return (
    <>
      <Tooltip
        title={
          isPortoBattery
            ? 'Não é permitido adicionar item em OS de bateria'
            : undefined
        }
      >
        <Button
          disabled={
            isPortoBattery ||
            isClosed ||
            isCancelled ||
            !hasPermissions([Authorities.MOVIMENTATION_WORKORDER_ADD_ITEM])
          }
          block
          type="primary"
          onClick={handleAddItemModalVisible}
        >
          <FormattedMessage id="workOrders.details.items.add" />
        </Button>
      </Tooltip>

      <WorkOrderItemModal
        open={opened}
        onCancel={handleAddItemModalVisible}
        onFinish={hanleModalFinish}
      />
    </>
  );
}
